<template>
    <div>
        <div class="row w-100 my-0 pb-0 col-md-12">
            <div class="col-md-12 mb-4">
                <p class="text-muted">
                    Create versions from new files or from existing assets
                </p>
            </div>
        </div>
        <div class="row w-100 my-0 pb-0 col-md-12">
            <h4 class="col-md-6">Linked Versions</h4>
        </div>
        <div class="row my-0 pb-0 w-100 col-md-12" v-if="assetVersions.length">
            <div class="col-md-12" data-id="asset-version-list">
                <div v-for="versionAsset in assetVersions" :key="versionAsset.id">
                    <div class="d-flex align-items-center justify-content-between w-100" >
                        <div class="d-flex align-items-center">
                            <div class="version-thumbnail-wrapper">
                                <img v-if="assetTypesMap.displayableImageTypes.includes(versionAsset.asset_type_id) && versionAsset.uri_internal" 
                                    :src="versionAsset.uri_internal" 
                                    class="version-list-thumbnail version-list-image w-100 h-100"
                                />
                                <div v-else class="asset-preview__icon-outer version-list-thumbnail w-100 h-100">
                                    <div class="asset-preview__icon-inner d-flex align-items-center justify-content-center">
                                        <i v-if="assetTypesMap.imagePlaceholderTypes.includes(versionAsset.asset_type_id)" 
                                            class="fa fa-file-image-o fa-2x text-dark" 
                                            aria-hidden="true"
                                        ></i>
                                        <i v-else-if="assetTypesMap.displayableVideoTypes.includes(versionAsset.asset_type_id)" 
                                            class="fa fa-file-video-o fa-2x text-dark" 
                                            aria-hidden="true"
                                        ></i>
                                        <i v-else-if="assetTypesMap.videoPlaceholderTypes.includes(versionAsset.asset_type_id)" 
                                            class="fa fa-file-video-o fa-2x text-dark" 
                                            aria-hidden="true"
                                        ></i>
                                        <i v-else class="fa fa-file-o fa-2x text-dark" aria-hidden="true"></i>
                                    </div>
                                </div>
                            </div>
                            <a class="ml-2 text-dark version-list-name"  :href="'/assets/' + versionAsset.id + '/edit'">
                                {{ versionAsset.name }}
                            </a>
                        </div>
                        <div>
                            <button v-if="!versionAsset.is_master" class="btn btn-sm btn-primary" @click="setVersionedAssetAsMaster(versionAsset.id)">
                                Set as Master
                            </button>
                            <button class="btn btn-sm btn-danger ml-2" @click="handleUnlinkVersion(versionAsset.id)"> 
                                Delete
                            </button>
                        </div>
                    </div>
                    <hr class="my-2">
                </div>
            </div>
        </div>
        <div v-else class="row my-0 pb-0 w-100 col-md-12">
            <div class="col-md-12 font-weight-bold mt-2 text-muted">
                This product has no related versions
            </div>
        </div>
        <div class="row w-100 mb-0 pb-0 col-md-12 mt-5">
            <h4 class="pb-2 col-md-6">Add Versions</h4>
        </div>
        <div class="row mt-0 mb-4 pb-0 w-100 col-md-12">
            <div class="col-md-12 mb-2 mt-0">
                <div class="d-flex align-items-end justify-content-start">
                    <div class="d-flex flex-column">
                        <label for="file" class="font-weight-bold">
                            Create version from new asset
                        </label>
                        <input type="file" ref="file" class="mb-2" data-id="asset-version-file" />
                    </div>
                    <div class="d-flex flex-column ml-2">
                        <label for="private" class="m-0">Private</label>
                        <input type="checkbox"
                            name="private"
                            style="width: 38px; height: 38px;"
                            v-model="createNewVersionedAsset.private"
                            class="form-control form-private"
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <button data-id="asset-version-file-submit" class="btn btn-primary" @click="handleCreateNewVersionedAsset">
                    New Version from File
                </button>
            </div>
        </div>
        <div class="row mb-0 pb-0 w-100 col-md-12">
            <div class="col-md-12 mb-2 mt-0">
                <div class="font-weight-bold">
                    Create version from existing asset
                </div>
            </div>
        </div>
        <div class="row my-0 pb-0 w-100 col-md-12">
            <div class="col-md-6">
                <base-filter-bar
                    placeholder="Search Assets"
                    class="mb-0 dam-search"
                ></base-filter-bar>
            </div>
        </div>
        <div class="row w-100 pb-0 col-md-12">
            <div class="col-md-12 d-flex flex-column align-items-end">
                <vuetable
                    ref="vuetable"
                    :fields="fields"
                    :api-url="apiURL"
                    :css="css.table"
                    :per-page="perPage"
                    :append-params="moreParams"
                    noDataTemplate="No Assets Found"
                    pagination-path=""
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                >
                    <template slot="grid-slot" slot-scope="props">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex">
                                <a :href="'/assets/' + props.rowData.id + '/edit'" class="d-flex align-items-center">
                                    <img :src="props.rowData.uri_internal"
                                        v-if="assetTypesMap.displayableImageTypes.includes(props.rowData.asset_type_id)"
                                        alt=""
                                        class="asset-items__grid-thumbnail"
                                        style="width: 6rem; height: 6rem; object-fit: contain;"
                                    />
                                    <img src="https://via.placeholder.com/500" v-else alt="" style="width: 6rem; height: 6rem; object-fit: contain;">
                                    <span class="text-dark ml-2">
                                        {{ props.rowData.name }}
                                    </span>
                                </a>
                            </div>
                            <button class="btn btn-sm btn-primary" 
                                v-if="props.rowData.id === selectedVersionAssetId" 
                                @click="handleSelectedVersionAsset(props.rowData.id)"
                            >
                                Selected
                            </button>
                            <button v-else class="btn btn-sm btn-outline-primary" @click="handleSelectedVersionAsset(props.rowData.id)">
                                Select
                            </button>
                        </div>
                    </template>
                </vuetable>
            </div>
            <div class="col-md-12 mt-2 w-100">
                <div class="row w-100 m-auto">
                    <div class="col-md-6 d-flex flex-column p-0">
                        <base-pagination-info :css="css.table" ref="paginationInfo">
                        </base-pagination-info>
                    </div>
                    <div class="col-md-6 d-flex justify-content-end pr-0">
                        <base-pagination
                            ref="pagination"
                            @vuetable-pagination:change-page="onChangePage"
                        ></base-pagination>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mt-2 w-100">
                <button class="btn btn-primary mr-2" 
                    :disabled="selectedVersionAssetId === ''" 
                    @click="createSelectedVersionedAsset"
                    data-id="asset-version-selected-submit"
                >
                    New Version from Selected
                </button>
                <button class="btn btn-outline-danger" 
                    :disabled="selectedVersionAssetId === ''" 
                    @click="selectedVersionAssetId = ''"
                >
                    Clear selected
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import BasePagination from "../tables/base-pagination.vue";
import BasePaginationInfo from "../tables/base-pagination-info.vue";
import BaseFilterBar from "../tables/base-filter-bar.vue";
import _ from 'lodash';
import Vue from 'vue'
import VueEvents from 'vue-events'
Vue.use(VueEvents)

const base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: "asset-versions",
    props: {
        asset: {
            required: true,
            type: Object
        },
        assetTypesMap: {
            required: true,
            type: Object
        }
    },
    components: {
        "base-pagination": BasePagination,
        "base-filter-bar": BaseFilterBar,
        "base-pagination-info": BasePaginationInfo,
    },
    data() {
        return {
            selectedVersionAssetId: '',  
            createNewVersionedAsset: {
                private: false,
                assetFolderId: ''
            }, 
            assetVersions: [],
            moreParams: {},
            perPage: 5,
            fields: [
                {
                    name: "__slot:grid-slot",
                    title: "",
                },
            ],
            css: {
                table: {
                    tableClass: "table table-middle table-minimal asset-version-list w-100",
                    ascendingIcon: "sort-icon-asc",
                    descendingIcon: "sort-icon-desc",
                    infoClass: "",
                    tableHeaderClass: "d-none",
                    tableBodyClass: "vuetable-body grid-body",
                },
            },
        }
    },
    mounted() {
        this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
        this.$events.$on("filter-reset", (e) => this.onFilterReset());

        this.fetchAssetVersions();      
    },
    computed: {
        apiURL() {
            return `${base_url}/pimapi/assets/grid?asset=${this.asset.id}`
        },
    },
    methods: {
        fetchAssetVersions() {
            axios.get(base_url + '/pimapi/assets/' + this.asset.id + '/version')
                .then(function(response) {
                    this.assetVersions = response.data.payload;

                }.bind(this))
                .catch(function(err) {
                    console.log(err);
                    this.$emit("alert", {
                        status: "alert-danger",
                        message: err.response.data.message || 'There was an error, please try again later.'
                    });
                }.bind(this));
        },
        handleUnlinkVersion(versionId) {
            axios.put(base_url + '/pimapi/assets/' + versionId + '/version/remove')
            .then(function(response) {
                this.$emit("alert", {
                    status: "alert-success",
                    message: "Success, asset version removed."
                });
            }.bind(this))
            .catch(function(err) {
                console.log(err);
                this.$emit("alert", {
                    status: "alert-danger",
                    message: err.response.data.message || 'There was an error, please try again later.'
                });
            }.bind(this));
        },
        
        setVersionedAssetAsMaster(asset) {
            this.versionFromExisting(asset);
        },
        createSelectedVersionedAsset() {
            this.versionFromExisting(this.selectedVersionAssetId);
        },
        versionFromExisting(assetId) {
            axios.put(base_url + '/pimapi/assets/' + this.asset.id + '/version', {
                assetId: assetId
            })
            .then(function(response) {
                this.$emit("alert", {
                    status: "alert-success",
                    message: "Success, asset version updated."
                });

                setTimeout(function() {
                    window.location.href = `/assets/${response.data.payload.id}/edit`;
                }, 2500)
            }.bind(this))
            .catch(function(err) {
                console.log(err);
                this.$emit("alert", {
                    status: "alert-danger",
                    message: err.response.data.message || 'There was an error, please try again later.'
                });
            }.bind(this));
        },
        onFilterSet: _.debounce(function (e) {
            this.moreParams.filter = e;

            this.$nextTick(() => this.$refs.vuetable.refresh());
        }, 300),
        onFilterReset() {
            this.moreParams.filter = '';

            this.$nextTick(() => this.$refs.vuetable.refresh());
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },
        onLoaded: function () {
            this.loading = false;
        },
        handleSelectedVersionAsset(assetId) {
            if (this.selectedVersionAssetId == assetId) {
                this.selectedVersionAssetId = '';
            } else {
                this.selectedVersionAssetId = assetId;
            }   
        },
        handleCreateNewVersionedAsset() {
            let formData = new FormData();

            formData.append('file', this.$refs.file.files[0]);
            formData.append('isPrivate', this.createNewVersionedAsset.private ? 1 : 0);

            axios.post(base_url + '/pimapi/assets', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }).then(function(response) {
                    let newVersionId = response.data.payload[0];

                    axios.put(base_url + '/pimapi/assets/' + this.asset.id + '/version', {
                            assetId: newVersionId
                        })
                        .then(function(response) {
                            this.fetchAssetVersions();
                            
                            this.$emit("alert", {
                                status: "alert-success",
                                message: "Success, asset version updated."
                            });
                        }.bind(this))
                        .catch(function(err) {
                            console.log(err);
                            this.$emit("alert", {
                                status: "alert-danger",
                                message: err.response.data.message || 'There was an error, please try again later.'
                            });
                        }.bind(this));

                }.bind(this))
                .catch(function(err) {
                    console.log(err);
                    
                    this.$emit("alert", {
                        status: "alert-danger",
                        message: err.response.data.message || 'There was an error, please try again later.'
                    });
                }.bind(this));
        },
    }
}
</script>

<style scoped lang="scss">
    .version-list-thumbnail {
        max-width: 4rem;
        max-height: 4rem;
        border-radius: 3px;
        border: 1px solid #dedede;
        object-fit: cover;
    }

    .version-list-name {
        max-width: 54ch;
        width: 90%;
    }
</style>
